module.exports = __webpack_public_path__ + "img/twitter.9e1fce3b.svg";